var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "k-menu" }, [
    _c("ul", { staticClass: "list" }, [
      _c("li", { staticClass: "item -active" }, [
        _vm._v("\n      clube\n    ")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "item" }, [
        _c(
          "a",
          {
            attrs: { target: "_blank", href: _vm.storeLink },
            on: { click: _vm.handleAnalytics }
          },
          [_vm._v("\n        store\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8df52602", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df52602","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/TopMenu.vue
// module id = 2019
// module chunks = 1610